import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

import AppPage from '@components/Layouts/AppPage/AppPage';
import AuthCard from '@components/molecules/AuthCard/AuthCard';
import { confirmConnectTwitter } from '../../api/airdrop/user';
import { sendToastNotification } from '../../utils/main.utils';

const ConfirmTwitterAccount = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const state = queryParams.get('state');
    const code = queryParams.get('code');
    if (!!state && !!code) {
      confirmConnectTwitter({ state, code })
        .then((res) => {
          sendToastNotification(`${res.username} account paired successfully!`, 'success');
        })
        .finally(() => {
          try {
            const redirectAfterConnectingX = localStorage.getItem('redirectAfterConnectingX');
            if (redirectAfterConnectingX) {
              navigate(redirectAfterConnectingX);
            } else {
              navigate('/profile');
            }
            localStorage.removeItem('redirectAfterConnectingX');
          } catch (e) {
            navigate('/profile');
          }
        });
    } else {
      sendToastNotification('Something went wrong!', 'error');
      try {
        const redirectAfterConnectingX = localStorage.getItem('redirectAfterConnectingX');
        if (redirectAfterConnectingX) {
          navigate(redirectAfterConnectingX);
        } else {
          navigate('/profile');
        }
        localStorage.removeItem('redirectAfterConnectingX');
      } catch (e) {
        navigate('/profile');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppPage keepHeaderSpace={true} hideFooter={true}>
      <div data-testid={'confirm-x'}>
        <AuthCard>
          <div className={'d-flex justify-content-center'}>
            <Spinner variant={'primary'} animation={'border'} />
          </div>
        </AuthCard>
      </div>
    </AppPage>
  );
};

export default ConfirmTwitterAccount;
